import 'systemjs';
import 'systemjs/dist/extras/amd';
import 'systemjs/dist/extras/dynamic-import-maps';
import 'systemjs/dist/extras/named-exports';
import { logger } from 'utils';

const { System } = window;

const registerEsmLoader = () => {
  const systemJSPrototype = window.System.constructor.prototype;

  const originalCreateScript = systemJSPrototype.createScript;
  systemJSPrototype.createScript = function () {
    return Object.assign(originalCreateScript.apply(this, arguments), { type: 'module' });
  };
  const originalInstantiate = systemJSPrototype.instantiate;
  systemJSPrototype.instantiate = function (url) {
    const isEsm = !!(url.match(/#esm$/) || url.split('#')[0].match(/\.(mjs|esm|ts|tsx|jsx)$/i));
    logger.info(`Loading module: ${url} (esm: ${isEsm})...`);
    if (isEsm) {
      return import(/* webpackIgnore: true, webpackMode: "lazy" */ url).then((m) => [
        [],
        (_export) => (_export(m), {}),
      ]);
    }

    return originalInstantiate.apply(this, arguments);
  };
};

registerEsmLoader();

export default System;
